<div class="right-panel h-100 d-flex flex-column text-grey">
  <h4 class="mt-0">Change colors to visualize the updated UI in realtime.</h4>
  <div class="settingsPanel mt-2" name="depSettingForm" [formGroup]="themeForm">
    <div class="settingRow" *ngFor="let key of themeKeys">
      <span class="settingTitle">{{ key | camelCaseConvert }} : </span>
      <input [formControlName]="key" [value]="existingTheme[key]" type="color" />
      <label for="" class="ms-2">{{ themeForm.get(key).value}}</label>
    </div>
  </div>
  <div class="bottom-panel" *ngIf="isMonitor == false">
    <button class="default-btn" (click)="onSave()">
      <span class="bi bi-save" aria-hidden="True" style="margin-right: 10px"></span>Save
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" [color]="existingTheme.primaryColor" type="ball-spin" name="themeConfigSpinner" [fullScreen]="false">
  <p>Please wait ...</p>
</ngx-spinner>